<template>
	<div class="group-info-page" v-loading="loading">
		<!-- 顶部导航 -->
		<div class="page-header" v-if="showHeader">
			<el-icon class="back-btn" @click="$emit('back')">
				<ArrowLeft />
			</el-icon>
			<!-- <el-icon class="close-btn" @click="$emit('close')">
				<Close />
			</el-icon> -->
		</div>
		
		<template v-if="['cg','g'].some(e=>e == mode)">
			<!-- 主体内容 -->
			<div class="page-content">
				<!-- 群头像 -->
				<div class="group-avatar">
					<img :src="ImageParameterSplicing(getAvatarurl||'',100)" @error="e=>e.target.src = defaultGroupChatAvatar">
				</div>
				<!-- 群名称 -->
				<div class="group-name">{{groupInfo.name}}({{groupInfo.memberCount}})</div>
			</div>
		</template>
		<template v-else-if="mode == 'u'">
			<!-- 主体内容 -->
			<div class="page-content">
				<!-- 用户头像 -->
				<div class="group-avatar">
					<img :src="ImageParameterSplicing(getAvatarurl||'',100)" @error="e=>e.target.src = defaultAnchor">
				</div>
				<!-- 用户名称 -->
				<div class="group-name">{{userInfo.nick}}</div>
			</div>
		</template>
		

		<!-- 底部按钮 -->
		<div class="page-footer">
			<template class="join-btn" disabled v-if="['cg','g'].some(e=>e == mode)">
				<el-button round size="small" class="join-btn notJoined" :loading="groupInfo.loading" v-if="!groupInfo.selfInfo?.isJoined&&groupInfo.selfInfo?.applyStatus==undefined" @click.stop="join(groupInfo)">进入群聊</el-button>
				<el-button round size="small" class="join-btn notJoined" v-else-if="!groupInfo.selfInfo.isJoined&&groupInfo.selfInfo.applyStatus != undefined" @click.stop="join(groupInfo)">{{getApplyStatus(groupInfo.selfInfo.applyStatus)}}</el-button>
				<el-button round size="small" class="join-btn joined" v-else @click="jump(groupInfo)">已加入</el-button>
			</template>
			<template v-if="mode == 'u'">
				<el-button class="join-btn" @click="toChat(userInfo)" 
				v-if="userInfo.relation == chatManager.TencentCloudChat.TYPES.SNS_TYPE_BOTH_WAY">
					<span >已添加</span>
				</el-button>
				<el-button class="join-btn" @click="addContact(userInfo)" 
				:class="{notJoined:userInfo.relation != chatManager.TencentCloudChat.TYPES.SNS_TYPE_BOTH_WAY}" 
				:loading="userInfo.loading"  v-else>
					<span >去添加</span>
				</el-button>
			</template>
		</div>
		<custom-dialog
			v-model="applyJoinGroupOpt.visible"
			:title="applyJoinGroupOpt.title"
			width="500px"
			@close="applyJoinGroupOpt.close"
			@confirm="applyJoinGroupOpt.submit"
			append-to-body
			>
			<div style="padding-top:15px;" v-loading="applyJoinGroupOpt.loading">
				<el-form
					ref="ruleFormRef"
					style="max-width: 600px"
					:model="applyJoinGroupOpt.form"
					:rules="applyJoinGroupOpt.rules"
					label-width="auto"
					@submit.prevent
				>
					<el-form-item label="申请理由" prop="applyReason">
						<el-input v-model="applyJoinGroupOpt.form.applyReason" />
					</el-form-item>
				</el-form> 
			</div>
		</custom-dialog>
	</div>
</template>

<script setup>
	import defaultAnchor from '@/assets/images/defaultAnchor.png';
	import defaultGroupChatAvatar from '@/assets/images/defaultGroupChatAvatar.png';
	import {ref,reactive,getCurrentInstance,onMounted,onUnmounted,computed,inject,watch,markRaw} from 'vue';
	import {useStore} from '@/store';
	let store = useStore();
	let {proxy} = getCurrentInstance();
	const chatManager = inject('chatManager');
	let props = defineProps({
		showHeader:{
			type:Boolean,
			default:true,
		}
	})
	let loading = ref(false);
	let mode = ref('');
	let show = async(url)=>{
		try{
			loading.value = true;
			if(/^https?:\/\/.*\/cg\/[a-zA-Z0-9]+$/.test(url)){
				// 社群
				mode.value = 'cg';
				let groupID = url.split('/cg/')[1];
				await searchGroupByID('@TGS#_'+groupID);
			}
			if(/^https?:\/\/.*\/g\/[a-zA-Z0-9]+$/.test(url)){
				// 普通群
				mode.value = 'g';
				let groupID = url.split('/g/')[1];
				await searchGroupByID(groupID);
			}
			// 用户名片
			if(/^https?:\/\/.*\/u\/[a-zA-Z0-9]+$/.test(url)){
				// 用户名片
				mode.value = 'u';
				let userID = url.split('/u/')[1];
				let vres =  await verifyUserNames(userID);
				if(vres?.data.code == 200){
					await getUserProfile(vres.data.data.map(e=>e.userID));
				}
			}
		}catch(err){
			console.log(err);
		}finally{
			loading.value = false;
		}
		
	}
	let verifyUserNames = async(userName)=>{
		return await proxy.request({
			url:'VerifyUserNames',
			method:'post',
			data:{
				userNames:[userName]
			},
			// notips:true,
		})
	}
	// 用户信息
	let userInfo = reactive({});
	// 获取用户信息
	let getUserProfile = async(userIDs)=>{
		let options = {
			userIDList: userIDs,
		};
		console.log('options',options);
		return (await chatManager.getChatClient()).getUserProfile(options).then(async res=>{
			proxy.clearObject(userInfo);
			if(res.data){
				Object.assign(userInfo,res.data[0]||{});
				console.log('用户的信息',userInfo);
				// 检查好友关系
				(await chatManager.getChatClient()).checkFriend(options).then(res=>{
					const { successUserIDList, failureUserIDList } = res.data;
					const { userID, code, relation } = successUserIDList[0]||{};
					userInfo.relation = relation;//chatManager.TencentCloudChat.TYPES.SNS_TYPE_BOTH_WAY
					if(userInfo.relation== chatManager.TencentCloudChat.TYPES.SNS_TYPE_BOTH_WAY){
						let o = {
							unreadCount:0,
							conversationID:chatManager.TencentCloudChat.TYPES.CONV_C2C+userInfo.userID,
							type:chatManager.TencentCloudChat.TYPES.CONV_C2C,
							userProfile:userInfo,
						}
						store.action.currChatUser.set(o);
						proxy.$router.push({
							path:'/message/msg',
							query:proxy.$route.query,
						})
						emit('closedialog');
					}
				})
			}
		})
	}
	let searchGroupByID = async(groupID)=>{
		return (await chatManager.getChatClient()).searchGroupByID(groupID).then(async res=>{
			proxy.clearObject(groupInfo);
			if(res.data){
				Object.assign(groupInfo,res.data.group);
				if(store.state.user.id){//登录了才需要发请求
					await getGroupUserStatus([res.data.group.groupID]).then(status=>{
						let has = status?.find(e=>e.groupId == res.data.group.groupID);
						if(has){
							Object.assign(groupInfo.selfInfo,{isJoined:has.isJoined,applyStatus:has.applyStatus});
							if(groupInfo.selfInfo.isJoined){
								// 已经入群了的直接进入会话
								let o = {
									conversationID:chatManager.TencentCloudChat.TYPES.CONV_GROUP+groupInfo.groupID,
									type:chatManager.TencentCloudChat.TYPES.CONV_GROUP,
									unreadCount:0,
									lastMessage:groupInfo.lastMessage,
									groupProfile:groupInfo,
								}
								store.action.currChatUser.set(o);
								proxy.$router.push({
									path:'/message/msg',
									query:proxy.$route.query,
								})
								setTimeout(()=>{ //延迟关闭
									emit('closedialog');
								},500)
							}
						}
					})
				}
				console.log('群组的信息',groupInfo);
			}
		})
	}
	// 群信息
	let groupInfo = reactive({});
	// 获取群资料
	// let getGroupProfile = async(groupID)=>{
	// 	let options = {
	// 		groupID
	// 	};
	// 	return (await chatManager.getChatClient()).getGroupProfile(options).then(async res=>{
	// 		proxy.clearObject(groupInfo);
	// 		if(res.data){
	// 			Object.assign(groupInfo,res.data.group);
	// 			console.log('群组的信息',groupInfo);
	// 		}
	// 	})
	// }
	let getAvatarurl = computed(()=>{
		let res = '';
		if(mode.value == 'cg'){
			res = store.state.startUp.configData?.defaultResDomains + groupInfo.avatar;//社群需要拼接图片资源域名
		}else if(mode.value == 'g'){
			res = groupInfo.avatar;
		}else if(mode.value == 'u'){
			res = userInfo.avatar;
		}
		return res;
	})
	
	// let campaignPromotionParams = {
	// 	page:1,
	// 	pageSize:15,
	// }
	// let campaignPromotionGroupList = reactive([]);
	// let initCampaignPromotionGroup = ()=>{
	// 	Object.assign(campaignPromotionParams,{
	// 		page:1,
	// 		pageSize:15,
	// 	})
	// 	return getCampaignPromotionGroup().then(async data=>{
	// 		campaignPromotionGroupList.length = 0;
	// 		if(data.length){
	// 			await getGroupUserStatus(data.map(e=>e.id)).then(res=>{
	// 				res?.forEach(e=>{
	// 					let has = data.find(d=>d.id == e.groupId);
	// 					if(has){
	// 						Object.assign(has,{isJoined:e.isJoined,applyStatus:e.applyStatus});
	// 					}
	// 				})
	// 			})
	// 		}
	// 		data.forEach(e=>campaignPromotionGroupList.push(e));
	// 	})
	// }
	let getGroupUserStatus = (groupIds)=>{
		return new Promise((resolve,reject)=>{
			proxy.request({
				url:"GroupUserStatus",
				method:"post",
				data:{
					groupIds,
				},
			}).then(({data})=>{
				if(data?.code == 200){
					resolve(data.data);
				}else{
					reject(data.msg);
				}
			}).catch(err=>{
				console.log(err);
				reject(err);
			})
		})
	}
	// let getCampaignPromotionGroup = ()=>{
	// 	return new Promise((resolve,reject)=>{
	// 		proxy.request({
	// 			url:"CampaignPromotionGroup",
	// 			method:"post",
	// 			data:campaignPromotionParams,
	// 		}).then(({data})=>{
	// 			if(data?.code == 200){
	// 				let _data = reactive(data.data||[]);
					
	// 				resolve(_data);
	// 			}else{
	// 				reject(data.msg);
	// 			}
	// 		}).catch(err=>{
	// 			console.log(err);
	// 			reject(err);
	// 		})
	// 	})
	// }
	let join = async(item)=>{
		console.log('去加入',item);
		if(!store.state.user.id){
			proxy.$bus.emit('showLogin');
			return 
		}
		if(item.selfInfo.applyStatus === 0){
			proxy.$message.warning('正在审核中...');
			return 
		}
		if(mode.value == 'cg'){
			item.loading = true;
			try{
				var _groupID = item.id||item.groupID;
				let res = await joinGroup(_groupID)
				console.log('joinGroup',res.data);
				if(res?.data.code != 200){
					throw new Error(res.data.msg);
				}
				if(res?.data.code == 200){
					if(res.data.data.needJoinApprove){//需要审核
						applyJoinGroupOpt.show(_groupID,'重新申请入群');
					}else{//直接入群
						item.isJoined = true;
						item.memberCount++;
						await proxy.awaitTime(300);
						await proxy.$confirm('加入成功，是否跳转会话界面？','提示',{
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							confirmButtonClass:'confirmButtonClass',
							type: 'success',
						}).then(async()=>{
							let o = {
								unreadCount:0,
								conversationID:chatManager.TencentCloudChat.TYPES.CONV_GROUP+_groupID,
								type:chatManager.TencentCloudChat.TYPES.CONV_GROUP,
								// lastMessage:item.lastMessage,
								groupProfile:Object.assign({},item,{groupID:_groupID}),
								subType:chatManager.TencentCloudChat.TYPES.GRP_COMMUNITY,
							}
							store.action.currChatUser.set(o);
							proxy.$router.push({
								path:'/message/msg',
								query:proxy.$route.query,
							})
						}).catch(()=>{
							
						})
						
					}
				}
			}catch(err){
				console.log(err);
			}finally{
				item.loading = false;
			}	
		}else{//调用SDK入群
			item.loading = true;
			(await chatManager.getChatClient()).joinGroup({
				groupID:item.groupID,
				// applyMessage:searchGroupOpt.form.applyMessage,//附言
			}).then(async res=>{
				switch (res.data.status) {
					case chatManager.TencentCloudChat.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
						proxy.$message.success('已申请,等待管理员同意');
						item.selfInfo.applyStatus = 0;
						item.selfInfo.isJoined = false;
						console.log(groupInfo);
					break;
					case chatManager.TencentCloudChat.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
						proxy.$message.success('加入成功');
						item.selfInfo.isJoined = true;
						item.selfInfo.userID = store.state.user.id;
						item.memberCount++;
						console.log(res.data.group); // 加入的群组资料
					break;
					case chatManager.TencentCloudChat.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
						proxy.$message.success('已经在群中');
						item.selfInfo.isJoined = true;
						item.selfInfo.userID = store.state.user.id;
					break;
					default:
					break;
				}
				await proxy.awaitTime(100);
				// createOrSearchGroup.visible = false;
			}).catch(err=>{
				proxy.$message.error('加入失败');
			}).finally(()=>{
				item.loading = false;
			})
		}
	}
	let joinGroup = (groupId)=>{
		return proxy.request({
			url:'JoinGroup',
			method:'post',
			data:{
				groupId,
			},
		})
	}
	let jump = (item)=>{
		proxy.$confirm('是否跳转会话界面？','提示',{
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			confirmButtonClass:'confirmButtonClass',
			type: 'success',
		}).then(async()=>{
			let subType = chatManager.TencentCloudChat.TYPES.GRP_COMMUNITY;
			if(mode.value == 'g'){
				subType = chatManager.TencentCloudChat.TYPES.GRP_PUBLIC;
			}
			let o = {
				unreadCount:0,
				conversationID:chatManager.TencentCloudChat.TYPES.CONV_GROUP+item.groupID,
				type:chatManager.TencentCloudChat.TYPES.CONV_GROUP,
				// lastMessage:item.lastMessage,
				groupProfile:Object.assign({},item,{groupID:item.groupID}),
				subType
			}
			store.action.currChatUser.set(o);
			proxy.$router.push({
				path:'/message/msg',
				query:proxy.$route.query,
			})
		}).catch(()=>{
			
		})
	}
	const emit = defineEmits(['closedialog']);
	let applyJoinGroupOpt = reactive({
		visible:false,
		loading:false,
		title:'',
		form:{
			groupId:'',
			applyReason:''
		},
		rules:[],
		close:()=>{
			applyJoinGroupOpt.loading = false;
			applyJoinGroupOpt.visible = false;
			applyJoinGroupOpt.form = {
				groupId:'',
				applyReason:''
			}
		},
		show:(groupID,title)=>{
			applyJoinGroupOpt.title = '申请入群';
			if(title!=undefined){
				applyJoinGroupOpt.title = title;
			}
			applyJoinGroupOpt.visible = true;
			applyJoinGroupOpt.form.groupId = groupID;
		},
		submit:async()=>{
			applyJoinGroupOpt.loading = true;
			applyJoinGroup().then(({data})=>{
				if(data?.code == 200){
					proxy.$message.success('已提交申请，待管理员审核');
					groupInfo.selfInfo.applyStatus = 0;//更变为审核状态
					applyJoinGroupOpt.visible = false;
				}
			}).finally(()=>{
				applyJoinGroupOpt.loading = false;
			})
		}
	})
	let applyJoinGroup = ()=>{
		return proxy.request({
			url:'ApplyJoinGroup',
			method:'post',
			data:applyJoinGroupOpt.form,
		})
	}
	
	// 0待审核 1审核通过 2审核拒绝 3已撤销，未申请时为空
	let getApplyStatus = (status)=>{
		let statusArr = [
			{value:0,label:'待审核'},
			{value:1,label:'审核通过'},
			{value:2,label:'审核拒绝'},
			{value:3,label:'已撤销'},
		];
		let has = statusArr.find(e=>e.value == status);
		let res = has?has.label:'';
		if(status==2){
			// res = '加入';
		}
		return res;
	}
	
	let addContact = async (userInfo)=>{
		userInfo.loading = true;
		addFriend(userInfo.userID).then(res=>{
			// 添加好友的请求发送成功
			const { code } = res.data;
			if (code === 30539) {
				// 30539 说明 user1 设置了【需要经过自己确认对方才能添加自己为好友】
				// 此时 SDK 会触发 TencentCloudChat.EVENT.FRIEND_APPLICATION_LIST_UPDATED 事件
				proxy.$message.success('已发出申请，请等待回复');
			} else if (code === 0) {
				// 0 说明 user1 设置了【允许任何人添加自己为好友】
				// 此时 SDK 会触发 TencentCloudChat.EVENT.FRIEND_LIST_UPDATED 事件
				proxy.$message.success('好友添加成功');
			}
		}).finally(()=>{
			userInfo.loading = false;
		})
	}
	let addFriend = async(userID,reason)=>{
		let params = {
			to:userID,
			source:'AddSource_Type_Web',
			wording:reason,
			type:chatManager.TencentCloudChat.TYPES.SNS_ADD_TYPE_BOTH,//双向加好友
		}
		return (await chatManager.getChatClient()).addFriend(params);
	}
	
	let toChat = (item)=>{
		proxy.$confirm('是否跳转会话界面？','提示',{
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			confirmButtonClass:'confirmButtonClass',
			type: 'success',
		}).then(async()=>{
			let o = {
				unreadCount:0,
				conversationID:chatManager.TencentCloudChat.TYPES.CONV_C2C+item.userID,
				type:chatManager.TencentCloudChat.TYPES.CONV_C2C,
				userProfile:item,
			}
			store.action.currChatUser.set(o);
			proxy.$router.push({
				path:'/message/msg',
				query:proxy.$route.query,
			})
		}).catch(()=>{
			
		})
	}
	
	defineExpose({
		show,
	})
	
	
</script>

<style lang="scss" scoped>
	.group-info-page {
		width: 100%;//308px
		height: 100%;//663px
		background-color: #ffffff;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		// padding: 20px;

		.page-header {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.back-btn {
				font-size: 24px;
				color: #333;
				cursor: pointer;
			}

			.close-btn {
				font-size: 24px;
				color: #fff;
				background-color: rgba(0, 0, 0, 0.5);
				border-radius: 50%;
				padding: 4px;
				cursor: pointer;
			}
		}

		.page-content {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 16px;

			.group-avatar {
				width: 80px;
				height: 80px;
				background: linear-gradient(135deg, #c0e850 0%, #39b54a 100%);
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 100%;
					height: 100%;
					object-fit: cover;
					border-radius: 50%;
				}
			}

			.group-name {
				font-size: 18px;
				color: #333;
				font-weight: 500;
			}
		}

		.page-footer {
			display: flex;
			justify-content: center;
			padding-bottom: 40px;

			.join-btn {
				width: 280px;
				height: 50px;
				font-size: 18px;
				background-color: #868e96;
				color: #ffffff;
				border: none;
				border-radius: 25px;
				&.notJoined{
					// border:1px solid var(--qx2-primary-color);
					// color:var(--qx2-primary-color);
					background: var(--qx2-primary-linearGradient-color);
					color:#fff;
				}
			}
		}
	}
</style>